import useScreenSize from "@/modules/common/hooks/device-detection.hook";
import { Box, SxProps, Theme, Typography, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import EditIcon from "@/assets/icons/lead-page/edit-icon";

interface InfoFieldProps {
  content: string | number | JSX.Element;
  editable?: boolean;
  editModal?: JSX.Element;
  setEditModalOpen?: (open: boolean) => void;
  editModalOpen?: boolean;
  sxInnerBox?: SxProps<Theme>;
  sxContentBox?: SxProps<Theme>;
  hidePenIcon?: boolean;
}

const LeadInfoField: React.FC<InfoFieldProps> = ({
  content,
  editable,
  editModal,
  setEditModalOpen,
  editModalOpen,
  sxInnerBox,
  sxContentBox,
  hidePenIcon,
}) => {
  const screen = useScreenSize();
  const theme = useTheme();
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  useEffect(() => {
    const isTouchScreen =
      "ontouchstart" in window || navigator.maxTouchPoints > 0;
    setIsTouchDevice(isTouchScreen);
  }, []);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          maxWidth: screen.isMobile ? "auto" : "220px",
          ...sxContentBox,
        }}
      >
        <Box
          sx={{
            display: "inline-flex",
            gap: theme.nawy.spacing.md,
            alignItems: "center",
            cursor: editable ? "pointer" : "default",
            position: "relative",
            "&:hover .edit-icon": {
              opacity: editable ? 1 : 0,
            },
            width: "fit-content",
            ...sxInnerBox,
          }}
          onClick={() => editable && setEditModalOpen && setEditModalOpen(true)}
        >
          <Typography
            sx={{
              ...theme.nawy.typography.english.variants.body.md.regular,
              color:
                content === "Not Set" || !content
                  ? theme.nawy.colors.semantic.text.tertiary
                  : theme.nawy.colors.semantic.text.primary,
              "&:hover": {
                textDecoration: editable ? "underline" : "none",
              },
              cursor: editable && !isTouchDevice ? "pointer" : "default",
              maxWidth: "250px",
              ...sxInnerBox,
              wordWrap: "break-word",
            }}
          >
            {content || "Not set"}
          </Typography>

          {editable && (
            <Box
              className="edit-icon"
              sx={{
                fontSize: 16,
                color: theme.nawy.colors.semantic.text.accent,
                opacity: screen.isMobile ? 1 : 0,
                transition: "opacity 0.2s ease-in-out",
                flexShrink: 0,
                display: "flex",
                alignItems: "center",
                minHeight: "24px",
              }}
            >
              {!hidePenIcon && <EditIcon />}
            </Box>
          )}
        </Box>
      </Box>
      {editModalOpen && editModal}
    </>
  );
};

export default LeadInfoField;
